(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const tickerWrappers = document.querySelectorAll(".ticker-wrapper");
    tickerWrappers.forEach((wrapper) => {
      const track = wrapper.querySelector(".ticker__track");
      const contents = wrapper.querySelectorAll(".ticker__content");
      if (!track || !contents.length) return;

      // Clone contents until we have enough to fill screen x3
      const totalWidth = () => Array.from(contents).reduce((sum, el) => sum + el.offsetWidth, 0);
      while (totalWidth() < window.innerWidth * 3) {
        contents.forEach(el => track.appendChild(el.cloneNode(true)));
      }

      // Get one content block width for seamless loop
      const singleWidth = contents[0].offsetWidth;

      const duration = getComputedStyle(wrapper).getPropertyValue("--scroll-speed").trim();
      const id = Math.random().toString(36).substr(2, 9);

      const style = document.createElement("style");
      style.textContent = `
        @keyframes ticker-${id} {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${singleWidth}px); }
        }
      `;
      document.head.appendChild(style);
      track.style.animation = `ticker-${id} ${duration} linear infinite`;

      wrapper.addEventListener("mouseenter", () => track.style.animationPlayState = "paused");
      wrapper.addEventListener("mouseleave", () => track.style.animationPlayState = "running");
    });
  });
})();